<template >
  <div id="user-info-card">
    <div class="user-info-card-info mb-5">
      <div class="info-section">
        <div class="section-header">
          <h2>Download History</h2>
          <div class="place-holder"></div>
        </div>
      </div>
      <div class="info-section">
        <!-- <table class="table table-bordered table-centered">
          <thead>
            <tr>
              <th>Date</th>
              <th>File name</th>
              <th>Credit Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" v-for="(info, index) in downloadList" :key="index">
              <td class="table-dark-cell">{{info.date.split('T')[0]}}</td>
              <td class="text-decoration-underline">{{info.filename}}</td>
              <td class="table-dark-cell">{{info.cost}}</td>
            </tr>
          </tbody>
        </table>-->

        <documentation-table
          v-if="downloadList"
          :columns="downloadCol"
          :data="downloadList"
          title
          description
        ></documentation-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DocumentationTable from "@/components/table/documentation-table";

export default {
  props: {
    label: {
      type: String,
      default: "label"
    }
  },
  components: {
    DocumentationTable
  },
  data() {
    return {};
  },
  computed: {
    downloadCol() {
      return [
        { id: 0, key: "date", label: "Date" },
        { id: 1, key: "filename", label: "Filename" },
        { id: 2, key: "cost", label: "Cost" }
      ];
    },
    // Tests:
    // downloadList() {
    //   return [
    //     {
    //       date: "2012T01",
    //       filename: "no name",
    //       cost: 2000
    //     }
    //   ].map(item => {
    //     return {
    //       date: item.date.split("T")[0],
    //       filename: item.filename,
    //       cost: item.cost
    //     };
    //   });
    // }
    ...mapState({
      downloadList: state =>
        state.UserService.userDownloadHistories.map(item => {
          return {
            date: item.date.split("T")[0],
            filename: item.filename,
            cost: item.cost
          };
        })
    })
  },
  methods: {}
};
</script>


<style lang="css" scoped>
* {
  font-family: Raleway;
  font-size: 0.875rem;
  /* font-weight: bold; */
  color: #656666;
  letter-spacing: 0.56px;
}

#user-info-card {
  background-color: white;
  height: 100%;
  overflow: auto;
}

.card-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.card-info-section {
  display: flex;
  flex-wrap: wrap;
}

#cardImg {
  margin: auto;
  width: 100px;
  height: 100px;
  object-fit: contain;
}

#cardTitle {
  letter-spacing: 0.71px;
  color: #ffffff;
}

.card-info {
  font-weight: normal;
  letter-spacing: 0.71px;
}

.user-info-card-info {
  padding: 1rem;
}

/* .info-section {
  margin-bottom: 1rem;
} */

.info-section h2 {
  /* font-size: 24px; */
  /* padding: 1rem 1.5rem; */
  font-weight: 600;
  margin: 0px;
  font-size: 1rem;
}

.card-cutomize-section {
  margin-top: 2px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon-plus {
  margin-top: 1px;
  margin-left: 2px;
}

.color-btn {
  letter-spacing: 0.59px;
  color: #ffffff;
  background: #f5a623;
  font-weight: bold;
  margin-right: 1rem;
  border: 1px solid #f5a623;
}

.update-input {
  border: 0;
  outline: 0;
  background: transparent;
}

.info-section > div {
  background-color: white;
  padding: 1rem 1.5rem;
}

.section-header {
  padding-bottom: 0 !important;
  margin-bottom: 2px;
  border-bottom: solid 0.4px rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header p {
  background-color: #26313a;
  letter-spacing: 0.59px;
  padding: 1rem;
}

.table-row p {
  opacity: 0.28;
  background-color: #22282d;
  letter-spacing: 0.47px;
  font-size: 16px;
  padding: 1rem;
}

.invoice-table > div {
  text-align: center;
}

.table-bordered {
  border: 0.4px solid #979797;
}

.table-centered {
  text-align: center;
  margin-top: 20px;
}

thead > tr > th {
  height: 42px;
}

tbody tr > td {
  height: 32px;
  font-size: 12px;
}

thead > tr > th {
  font-size: 14px;
}

.table-dark-cell {
  background-color: #d8d8d84d;
}

.text-decoration-underline {
  text-decoration: underline;
}

.place-holder {
  height: 2.5rem;
}

@media only screen and (min-width: 992px) {
  * {
    font-size: 1rem;
    letter-spacing: 0.47px;
  }
  #user-info-card {
    padding: 3rem 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/download-info-card.vue